import React from 'react';

/** Ocean — the problem-statement registry. Waves, to sit alongside the
 *  Cosmos spiral without competing with it. */
export const OceanIcon = ({ active }: { active: boolean }) => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 8.5c1.9 0 1.9-1.6 3.8-1.6s1.9 1.6 3.8 1.6 1.9-1.6 3.8-1.6 1.9 1.6 3.8 1.6 1.9-1.6 3.8-1.6"
      stroke={active ? '#9A7A4C' : 'currentColor'} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M2.5 13.2c1.9 0 1.9-1.6 3.8-1.6s1.9 1.6 3.8 1.6 1.9-1.6 3.8-1.6 1.9 1.6 3.8 1.6 1.9-1.6 3.8-1.6"
      stroke={active ? '#9A7A4C' : 'currentColor'} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
      opacity="0.75" />
    <path
      d="M2.5 17.9c1.9 0 1.9-1.6 3.8-1.6s1.9 1.6 3.8 1.6 1.9-1.6 3.8-1.6 1.9 1.6 3.8 1.6 1.9-1.6 3.8-1.6"
      stroke={active ? '#9A7A4C' : 'currentColor'} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
      opacity="0.5" />
  </svg>
);
